import React from "react";

const hexToRgba = (hex, alpha) => {
  const h = (hex || "#f3f3f3").replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

const DesktopPreview = ({
  primaryColor,
  secondaryColor,
  backgroundColor,
  textPrimary,
  textSecondary,
  logoBase64,
  backgroundImage,
  languageSelectorColor,
  buttonColor1,
  buttonColor2,
  buttonText,
  iconsColor,
}) => {
  const grad = `linear-gradient(to right, ${primaryColor || "#01315f"}, ${secondaryColor || "#067ddb"})`;
  const bg  = backgroundColor || "#f3f3f3";
  const tp  = textPrimary    || "#01315f";
  const ts  = textSecondary  || "#444444";
  const lsc = languageSelectorColor || "#ffffff";
  const bc1 = buttonColor1   || "#01315f";
  const bc2 = buttonColor2   || "#067ddb";
  const bt  = buttonText     || "#ffffff";
  const ic  = iconsColor     || "#01315f";

  const btnBase = {
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    fontSize: "11px",
    fontWeight: 600,
    cursor: "default",
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: "56.25%",
        backgroundColor: bg,
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        fontFamily: "sans-serif",
      }}
    >
      {/* Header */}
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0,
          height: "46px",
          background: grad,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 16px",
          zIndex: 2,
        }}
      >
        <img
          src={logoBase64 || "/images/logo_white.png"}
          alt="Logo"
          style={{ height: "22px", width: "auto", maxWidth: "120px", objectFit: "contain", flexShrink: 0, display: "block" }}
        />
        <div style={{ color: lsc, display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", fontWeight: 600 }}>
          <i className="fas fa-globe" style={{ fontSize: "11px" }}></i>
          <span>ES</span>
        </div>
      </div>

      {/* Body */}
      <div
        style={{
          position: "absolute",
          top: "46px", left: 0, right: 0, bottom: 0,
          backgroundColor: backgroundImage ? hexToRgba(bg, 0.88) : bg,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px 18px",
          gap: "9px",
        }}
      >
        <i className="fas fa-lock" style={{ fontSize: "20px", color: ic }}></i>

        <div style={{ textAlign: "center" }}>
          <div style={{ color: tp, fontSize: "13px", fontWeight: 700, marginBottom: "3px" }}>Selecciona tu taquilla</div>
          <div style={{ color: ts, fontSize: "10px", lineHeight: 1.4 }}>Elige el tipo y el tiempo de alquiler</div>
        </div>

        <div style={{ display: "flex", gap: "7px", flexWrap: "wrap", justifyContent: "center" }}>
          <button style={{ ...btnBase, background: bc1, color: bt }}>
            <i className="fas fa-box" style={{ fontSize: "9px", color: bt }}></i>
            Pequeña
          </button>
          <button style={{ ...btnBase, background: bc2, color: bt }}>
            <i className="fas fa-box" style={{ fontSize: "9px", color: bt }}></i>
            Mediana
          </button>
          <button style={{ ...btnBase, background: bc1, color: bt }}>
            <i className="fas fa-box" style={{ fontSize: "9px", color: bt }}></i>
            Grande
          </button>
        </div>

        <button style={{ ...btnBase, background: bc1, color: bt, padding: "8px 22px", borderRadius: "8px" }}>
          <i className="fas fa-check" style={{ fontSize: "9px" }}></i>
          Continuar
        </button>
      </div>
    </div>
  );
};

export default DesktopPreview;
